import { RebateResource } from "@/interfaces";

// The API localizes `name` from the server locale, which doesn't follow the
// customer's portal language, so pick the language-specific column ourselves.
export const localizedRebateTypeName = (
  rebate: RebateResource,
  language: string,
): string | null => {
  const rebateType = rebate.relationships?.type?.data?.attributes;

  if (!rebateType) {
    return null;
  }

  return (
    (language === "fr" ? rebateType.name_fr : rebateType.name_en) ||
    rebateType.name ||
    null
  );
};
